import { tv } from 'tailwind-variants'

export const quoteSectionRow = tv({
  slots: {
    container: 'flex-col pt-12',
    row: 'flex-row items-center justify-between py-3',
    left: 'flex-1 flex-row items-center gap-x-3',
    divider: 'h-px bg-grey-100',
  },
})
